var render = function render(){var _vm=this,_c=_vm._self._c;return _c('horizontal-nav',{staticClass:"m-b-10",attrs:{"set_view":"","show_display":false,"items":_vm.items}})
}
var staticRenderFns = []

export { render, staticRenderFns }